import { apiClient } from './api';
import { ApiResponse, Notification, NotificationFilters } from '@/types';

export interface NotificationsListResponse {
  notifications: Notification[];
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export const notificationsApi = {
  async getNotifications(
    filters?: NotificationFilters
  ): Promise<ApiResponse<NotificationsListResponse>> {
    const queryParams = new URLSearchParams();

    if (filters?.isRead !== undefined) {
      queryParams.append('isRead', String(filters.isRead));
    }

    if (filters?.type) {
      queryParams.append('type', filters.type);
    }

    if (filters?.limit !== undefined) {
      queryParams.append('limit', filters.limit.toString());
    }

    if (filters?.offset !== undefined) {
      queryParams.append('offset', filters.offset.toString());
    }

    const query = queryParams.toString();
    const endpoint = `/profile/notifications/${query ? `?${query}` : ''}`;
    const response = await apiClient.get<NotificationsListResponse>(endpoint);
    return response;
  },

  async markAsRead(id: string): Promise<ApiResponse<{}>> {
    return apiClient.post<{}>(`/notifications/${id}/read`);
  },

  async acceptInvite(id: string): Promise<ApiResponse<{}>> {
    return apiClient.post<{}>(`/notifications/${id}/accept`);
  },

  async declineInvite(id: string): Promise<ApiResponse<{}>> {
    return apiClient.post<{}>(`/notifications/${id}/decline`);
  },

  async reinviteCoauthor(id: string): Promise<ApiResponse<{}>> {
    return apiClient.post<{}>(`/notifications/${id}/reinvite`);
  },

  async markAllAsRead(): Promise<ApiResponse<{ success: boolean }>> {
    return apiClient.post<{ success: boolean }>('/notifications/read-all');
  },

  async deleteNotification(
    id: string
  ): Promise<ApiResponse<{ success: boolean }>> {
    return apiClient.delete<{ success: boolean }>(`/notifications/${id}`);
  },
};
